<style lang="less">
  // @import '../flow.less';
  @import '../../base.less';
</style>

<template>
    <div className='description'>
      <Steps :current="currentStep" :status="status_own">
        <Step v-for="item in stepsElements" :key="item.id" :title="item.title" v-html="item.content" @click.native="click(item.title, item.id, item.status, item.step, $event)">
        </Step>
      </Steps>
      <!-- <Modal v-model="visible" draggable scrollable title="Modal 2">
          <div>This is the second modal</div>
      </Modal> -->
    </div>
</template>
<script>
import { approvalFlow } from '@/api/workflow/approval'
import moment from 'moment'

export default {
  name: 'Approves',
  components: {
  },
  props:
    { 'approves': Array,
      'status': Number,
      'approveType': {
        type: String,
        required: true
      },
      'reFresh': {
        type: Function
      }
    },
  // props: ['statusParent'],
  data () {
    return {
      moment: moment,
      stepsElements: [],
      currentStep: 0,
      // approves_own: this.approves,
      status_own: this.status,
      visible: false,
      approveContent: '同意',
      approveSel: 'agree',
      approveStep: '',
      approveId: '',
      approve_type_own: this.approveType
    }
  },
  watch: {
    status () {
      this.status_own = this.status
    },
    approves: {
      handler (newName, oldName) {
        this.InitData()
      },
      immediate: true
    },
    approveType () {
      this.approve_type_own = this.approveType
    }
  },
  methods: {
    InitData () {
      console.log(33333333333)
      this.currentStep = 0
      let stepsElementsTmp = []
      let stepsElement = {}
      let approveStatus = 'process'
      if (['refuse', 'cancel', 0].indexOf(this.status_own) >= 0) {
        approveStatus = 'error'
      } else if (['done', 'success', 9].indexOf(this.status_own) >= 0) {
        approveStatus = 'finish'
      } else {
        approveStatus = 'process'
      }
      // 设置state
      // this.approves = this.approves ? this.approves : []
      // this.currentApproveId = null
      this.visible = false
      this.status_own = approveStatus
      // 展示步骤数据
      if (this.approves instanceof Array) {
        let countStep = 0
        // 可以设置当前step的标记
        let currentStepFlag = true
        this.approves.map((item, index) => {
          countStep = index + 1
          let contentHtml = ''
          let divUser = ''
          let divTimeEnd = ''
          let divContent = ''
          let divApprove = ''
          if (item.user) {
            divUser = '<div className="user">审批者:' + (item.user.name ? item.user.name : item.user.username) + '</div>'
          } else {
            divUser = ''
          }
          if (item.content) {
            divContent = '<div className="user">备注:' + item.content + '</div>'
          } else {
            divContent = ''
          }
          if (item.ended_at) {
            divTimeEnd = '<div className="time">' + moment(item.ended_at).format('YYYY-MM-DD HH:mm:ss') + '</div>'
          } else {
            divTimeEnd = ''
          }
          if (item.status === 'agree' && currentStepFlag) {
            // 当前这个item可以审批，同时设置currentStepFlag为false，这样后面的如果也是agree就不会修改currentStep的值了
            this.currentStep = index + 1
            // currentStepFlag = false;
            contentHtml = '<div class="ivu-steps-tail"><i></i></div><div class="ivu-steps-head"><div class="ivu-steps-head-inner"><span>' + countStep + '</span></div></div>' +
              '<div class="ivu-steps-main"><div class="ivu-steps-title">' + item.step + '</div> <div class="ivu-steps-content">' +
              '<div className="status">状态:' + item.status_verbose + '</div>' +
              divUser +
              divContent +
              divTimeEnd +
              '</div></div>'
            stepsElement = { 'title': item.step, 'content': contentHtml, 'id': item.id }
            stepsElementsTmp.push(stepsElement)
          } else {
            if (this.currentStep === index && this.status_own === 'process') {
              if (item.can_approve) {
                divApprove = '<div className="approve"><button type="button"  class="ivu-btn ivu-btn-primary">审批</button></div>'
              }
            }
            contentHtml = '<div class="ivu-steps-tail"><i></i></div><div class="ivu-steps-head"><div class="ivu-steps-head-inner"><span>' + countStep + '</span></div></div>' +
            '<div class="ivu-steps-main"><div class="ivu-steps-title">' + item.step + '</div> <div class="ivu-steps-content">' +
            '<div className="status">状态:' + item.status_verbose + '</div>' +
            divUser +
            divContent +
            divTimeEnd +
            divApprove +
            '</div></div>'
            stepsElement = { 'title': item.step, 'content': contentHtml, 'id': item.id, 'status': item.status, 'step': index }
            stepsElementsTmp.push(stepsElement)
          }
        })
        // steps html
        this.stepsElements = stepsElementsTmp
      }
    },
    handleRender (approveId) {
      this.$Modal.confirm({
        title: this.approveStep + '审批',
        content: '<p>Content of dialog</p><p>Content of dialog</p>',
        onOk: () => {
          // if (this.status === 5 && this.approveType === 'code_release' && !this.docCodeAddress) {
          //   this.$Notice.error({
          //     title: '请先填写文档和代码存放地址 ！'
          //   })
          //   return
          // }
          let data = { 'content': this.approveContent, 'status': this.approveSel }
          this.handleSubmit(approveId, data)
        },
        render: (h) => {
          return h('div', [
            // h('Divider', {
            // }, this.value + '审批'),
            h('Input', {
              props: {
                type: 'textarea',
                value: this.approveContent,
                autofocus: true,
                placeholder: '请输入审批说明'
              },
              style: {
                width: '90%'
              },
              on: {
                input: (val) => {
                  this.approveContent = val
                }
              }
            }),
            h('br', {
            }),
            h('br', {
            }),
            h('RadioGroup', {
              props: {
                type: 'button',
                value: this.approveSel
              },
              on: {
                'on-change': (val) => {
                  this.approveSel = val
                  if (val === 'agree') {
                    this.approveContent = '同意'
                  } else {
                    this.approveContent = '拒绝'
                  }
                }
              }
            }, [
              h('Radio', {
                props: {
                  label: 'agree'
                } }, '同意'),
              h('Radio', {
                props: {
                  label: 'refuse'
                } }, '拒绝')
            ])
          ])
        }
      })
    },
    handleSubmit (id, data) {
      approvalFlow(data, id, this.approve_type_own).then(res => {
        if (res.data.id === id) {
          this.reFresh()
          this.$Notice.success({
            title: '审批完成！'
          })
        }
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    click (title, id, status, step, event) {
      // console.log('click')
      let e = event || window.event
      var target = e.target || e.srcElement
      if (target.nodeName.toLowerCase() === 'button') {
        if (status === 'todo' && this.currentStep === step) {
          this.approveStep = title
          this.approveId = id
          this.handleRender(this.approveId)
        }
      }
    }
  },
  mounted: function () {
    // this.InitData()
  }
}
</script>
